const CART_FREE_SHIPPING_SECTION = 'cart-free-shipping-progress';

function getMainProductSectionId() {
  const productBlock = document.querySelector('[data-product-free-shipping]');
  if (!productBlock) return null;
  const sectionRoot = productBlock.closest('section[data-section]');
  return sectionRoot?.dataset?.section || null;
}

function getCartFreeShippingSectionKeys(sections) {
  const keys = sections.map((entry) => entry.section || entry.id).filter(Boolean);
  if (!keys.includes(CART_FREE_SHIPPING_SECTION)) {
    keys.push(CART_FREE_SHIPPING_SECTION);
  }
  const mainProductSectionId = getMainProductSectionId();
  if (mainProductSectionId && !keys.includes(mainProductSectionId)) {
    keys.push(mainProductSectionId);
  }
  return keys.join(',');
}

function updateProductFreeShippingProgress(parsedState) {
  const sectionId = getMainProductSectionId();
  if (!sectionId) return;

  const sectionHtml = parsedState?.sections?.[sectionId];
  if (!sectionHtml) return;

  const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
  const source = doc.querySelector('[data-product-free-shipping]');
  if (!source) return;

  document.querySelectorAll('[data-product-free-shipping]').forEach((target) => {
    target.innerHTML = source.innerHTML;
  });
}

function updateCartFreeShippingProgressBars(parsedState) {
  const sectionHtml = parsedState?.sections?.[CART_FREE_SHIPPING_SECTION];
  if (!sectionHtml) return;

  const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
  const source = doc.querySelector('[data-cart-free-shipping-update]');
  if (!source) return;

  document.querySelectorAll('[data-cart-free-shipping-update]').forEach((target) => {
    if (target.closest('[data-product-free-shipping]')) return;
    target.innerHTML = source.innerHTML;
    target.className = source.className;
    if (source.dataset.threshold) {
      target.dataset.threshold = source.dataset.threshold;
    } else {
      delete target.dataset.threshold;
    }
  });
}

function updateCartFreeShippingSections(parsedState) {
  if (!parsedState?.sections) return;
  updateProductFreeShippingProgress(parsedState);
  updateCartFreeShippingProgressBars(parsedState);
}

window.getCartFreeShippingSectionKeys = getCartFreeShippingSectionKeys;
window.updateCartFreeShippingSections = updateCartFreeShippingSections;
